import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { Link, useLocation } from "react-router-dom";
const IoArrowBack = require("react-icons/io5").IoArrowBack;

const AspirasiAllPejabat = () => {
  const [aspirasiList, setAspirasiList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [filterStatus, setFilterStatus] = useState(""); // "sudah" / "belum"
  const [selectedAspirasi, setSelectedAspirasi] = useState<any | null>(null);
  const [meta, setMeta] = useState({
    current_page: 1,
    per_page: 10,
    total: 0,
    last_page: 1,
  });

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const statusFromUrl = params.get("status");
    if (statusFromUrl) {
      setFilterStatus(statusFromUrl);
    }
  }, [location.search]);

  const fetchAspirasi = async (page = 1) => {
    setLoading(true);
    try {
      const token = Cookies.get("token");
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/aspirasi-all-pejabat`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          search: search || "",
          status: filterStatus || "",
          page,
          per_page: meta.per_page,
        },
      });

      setAspirasiList(res.data.data || []);
      setMeta(res.data.meta || meta);
    } catch (err) {
      console.error("Gagal ambil data aspirasi:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAspirasi(1);
  }, [filterStatus]);

  useEffect(() => {
    const debounce = setTimeout(() => fetchAspirasi(1), 400);
    return () => clearTimeout(debounce);
  }, [search, filterStatus]);

  return (
    <div className="overflow-x-auto mt-7">
      <div className="flex items-center gap-3 mb-6">
        <Link to={`/dashboard/beranda`} className="flex items-center gap-2 text-primary hover:text-yellow-800 transition">
          <IoArrowBack className="text-xl" />
          <span className="font-medium">Kembali</span>
        </Link>
      </div>
      <div className="flex flex-col md:flex-row justify-between items-center mb-4 gap-3">
        <h2 className="text-xl font-bold">Daftar Aspirasi</h2>

        <div className="flex gap-3 items-center">
          <select className="border px-3 py-2 rounded-lg text-sm" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
            <option value="">Semua Status</option>
            <option value="sudah">Sudah Dijawab</option>
            <option value="belum">Belum Dijawab</option>
          </select>
          <input type="text" placeholder="Cari judul atau nama..." value={search} onChange={(e) => setSearch(e.target.value)} className="border px-3 py-2 rounded-lg text-sm" />
        </div>
      </div>

      <table className="min-w-full border border-gray-300 text-sm md:text-base rounded-lg">
        <thead className="bg-primary text-black2">
          <tr>
            <th className="p-2 text-left">No</th>
            <th className="p-2 text-left">Nama</th>
            <th className="p-2 text-left">Judul</th>
            <th className="p-2 text-left">Pejabat</th>
            <th className="p-2 text-left">Status</th>
            <th className="p-2 text-left">Aksi</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={6} className="text-center p-4">
                <div className="flex justify-center items-center h-40">
                  <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-primary"></div>
                </div>
              </td>
            </tr>
          ) : aspirasiList.length > 0 ? (
            aspirasiList.map((item: any, index: number) => (
              <tr key={item.id} className="border-b hover:bg-gray-100">
                <td className="p-2">{(meta.current_page - 1) * meta.per_page + index + 1}</td>
                <td className="p-2">{item.user?.name || "-"}</td>
                <td className="p-2 font-semibold">{item.judul}</td>
                <td className="p-2">{item.presiden?.nama || "-"}</td>
                <td className="p-2">
                  {item.balasan ? <span className="px-3 py-1 rounded-full bg-green-500 text-white text-xs">Sudah Dijawab</span> : <span className="px-3 py-1 rounded-full bg-red-500 text-white text-xs">Belum Dijawab</span>}
                </td>
                <td className="p-2">
                  <button onClick={() => setSelectedAspirasi(item)} className="text-blue-600 underline">
                    Detail
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={6} className="text-center p-4">
                Tidak ada data
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="flex justify-end items-center mt-4 text-sm">
        <div className="flex gap-2">
          <button disabled={meta.current_page === 1} onClick={() => fetchAspirasi(meta.current_page - 1)} className={`px-3 py-1 rounded border ${meta.current_page === 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200"}`}>
            Prev
          </button>
          <button className="text-xs">
            {meta.current_page} / {meta.last_page}
          </button>
          <button
            disabled={meta.current_page === meta.last_page}
            onClick={() => fetchAspirasi(meta.current_page + 1)}
            className={`px-3 py-1 rounded border ${meta.current_page === meta.last_page ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200"}`}>
            Next
          </button>
        </div>
      </div>

      {/* Modal Detail */}
      {selectedAspirasi && (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
          <div className="bg-white w-[90%] max-w-2xl p-6 rounded-lg shadow-lg relative">
            <button onClick={() => setSelectedAspirasi(null)} className="absolute top-3 right-3 text-gray-600 hover:text-black">
              ✕
            </button>
            <h3 className="text-lg font-bold mb-4">Detail Aspirasi</h3>
            <div className="space-y-2 text-sm">
              <p>
                <strong>Nama Pengirim:</strong> {selectedAspirasi.user?.name || "-"}
              </p>
              <p>
                <strong>Judul:</strong> {selectedAspirasi.judul}
              </p>
              <p>
                <strong>Isi Aspirasi:</strong> {selectedAspirasi.deskripsi}
              </p>
              <p>
                <strong>Pejabat Tujuan:</strong> {selectedAspirasi.presiden?.nama || "-"}
              </p>
              <p>
                <strong>Status:</strong> {selectedAspirasi.balasan ? "Sudah Dijawab" : "Belum Dijawab"}
              </p>
              {selectedAspirasi.balasan && (
                <p>
                  <strong>Balasan:</strong> {selectedAspirasi.balasan}
                </p>
              )}
              <p>
                <strong>Tanggal Dibuat:</strong>{" "}
                {selectedAspirasi.created_at
                  ? new Date(selectedAspirasi.created_at).toLocaleDateString("id-ID", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })
                  : "-"}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AspirasiAllPejabat;
